<template>
  <div class="h-[80vh] py-5 font-cronosPro">
    <div class="px-4 py-0.5 pb-3 w-full flex items-center gap-x-2 border-b border-gray-300">
      <faInfoCircle class="w-6 fill-brand-red" />
      <p>
        {{ $t('cameraNotAvailable') }}
      </p>
    </div>
    <div class="w-full p-5">
      <p class="w-full">
        {{ $t('cameraNotAvailableDescription') }}
      </p>
    </div>
    <div class="px-4 w-full flex justify-end gap-x-4 items-center">
      <button
        class="px-6 py-1.5 rounded-md bg-gradient-to-br from-linear-s to-linear-e text-white flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
        @click.prevent="$emit('onTransition', 'initial')"
      >
        <span class="px-2 ltr:font-sans tracking-wide text-white text-sm pb-[1px]">
          {{ $t('OK') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import faInfoCircle from '@/assets/icons/faInfoCircle.svg?component'
import ocrUploadIcon from '@/assets/icons/ocrUpload.svg?component'
import faTimes from '@/assets/icons/faTimes.svg?component'
import { useOcrStore } from '@/stores/ocr'

const ocrStore = useOcrStore()
</script>

<style lang="scss" scoped></style>
